import React from 'react' // eslint-disable-line no-unused-vars
import InputGroup from '../../forms/InputGroup'
import Textarea from '../../forms/Textarea'
import TagGroup from '../../forms/TagGroup'
import Select from '../../forms/Select'
import moment from 'moment'
import CountryAwareComponent from '../CountryAwareComponent'
import StaticConfig from '../StaticConfig'
import { ABBVIE_EMPLOYEE } from '../../constants'
import AttachDocuments from './AttachDocuments'
import DocumentsCart from './DocumentsCart'

class RequestInformation extends CountryAwareComponent {
  constructor (props) {
    super(props)
    this.responseOptions = props.responseOptions
    this.products = []
    this.countryList = []
    this.indications = []
    this.deliveryMethods = []
    this.handleDeliveryMethodChange = this.handleDeliveryMethodChange.bind(this)
    this.handleResponseChange = this.handleResponseChange.bind(this)
    this.onCountryChange = this.onCountryChange.bind(this)
    this.handleProductSelect = this.handleProductSelect.bind(this)
    this.state = {
      indications: []
    }
    this.componentName = 'RequestInformation'

    // If navigating from the details page, the product field should be autofilled with that product
    // and the indication options should be updated
    if (props.fields.product.value) {
      this.handleProductSelect(props.fields.product.value, null)
    }
  }

  componentWillReceiveProps = nextProps => {
    const { fields, products, indicators, flowType } = nextProps
    if (fields.product.options.indexOf(fields.product.value) !== -1) {
      this._setIndicationOptionsForSelectedProduct(
        fields.product.value,
        flowType,
        products,
        indicators
      )
    } else {
      this.indications = []
    }
  };

  _reset = () => {
    if (this.props.fields.respondedWith.display) {
      this.tagGroupField._reset()
    }
  };

  handleDeliveryMethodChange (value, field) {
    this.handleResponseChange('', this.props.fields.responseDeadline)
    if (value === 'Mail') {
      this.responseOptions = this.props.responseOptions.filter(function (
        option
      ) {
        return option.value === 15
      })
    } else {
      this.responseOptions = this.props.responseOptions
    }
    this.props.updateValidationField(value)
  }

  onCountryChange (event) {
    this.indications = []
    if (this.props.onRequesterCountryChange) {
      this.props.onRequesterCountryChange(event)
    }
  }

  validationData (fields) {
    this.props.validationData(fields)
  }

  handleResponseChange (value, field) {
    if (value === '') {
      field.value = ''
      field.displayValue = ''
      return
    }

    var responseDueDate = moment(new Date())
    responseDueDate = responseDueDate.add(value, 'days')
    field.displayValue = responseDueDate.format('YYYY-MM-DD')
  }

  handleProductSelect (value, field) {
    const { productMasters: prodMaster, flowType, indicators } = this.props
    this._setIndicationOptionsForSelectedProduct(
      value,
      flowType,
      prodMaster,
      indicators
    )
    this.props.onProductChange(this.indications, value)
  }

  _setIndicationOptionsForSelectedProduct = (
    selectedProduct,
    flowType,
    productList,
    indicators
  ) => {
    productList = productList.filter(function (option) {
      return option.productCode === selectedProduct
    })
    if (productList.length > 0 && flowType === 'MI_PORTAL_REQUEST') {
      var id = productList[0].id
      var relevantIndications = indicators.filter(function (option) {
        return option.productId === id
      })

      this.indications = relevantIndications.map(function (ind) {
        return {
          value: ind.name,
          label: ind.translation || ind.name
        }
      })
    }
  };

  componentDidMount () {
    if (StaticConfig.Context.Country.isGMISEnable === 0) {
      this.handleDeliveryMethodChange('Email', this.props.fields.deliveryMethod)
      // this.handleResponseChange(15, this.props.fields.responseDeadline);
      // this.props.fields.responseDeadline.value= 15;
    }
  }

  render () {
    const {
      products: approverProducts,
      flowType,
      lang: languageContent
    } = this.props
    this.products = approverProducts.map(function (product) {
      return {
        value: product.productCode,
        label: product.name
      }
    })
    this.deliveryMethods = this.props.deliveryMethods.map(function (method) {
      return {
        value: method.delivery,
        label: method.translation || method.delivery
      }
    })
    this.countryList = this.props.countries.map(function (country) {
      return {
        value: country.name,
        label: country.name
      }
    })

    if (flowType === 'SCIBOOTH') {
      this.deliveryMethods = this.deliveryMethods.filter(
        element => element.value !== 'Mail'
      )
    }
    const jsx = (
      <div>
        <div className='row m-t-10'>
          {this.props.fields.country.display ? (
            <div className='col-lg-3 m-b-15'>
              <Select
                searchable
                clearable={false}
                disabled={
                  StaticConfig.Context.UserType !== ABBVIE_EMPLOYEE &&
                  flowType === 'MI_PORTAL_REQUEST'
                }
                options={this.countryList}
                field={this.props.fields.country}
                deleteRemoves={false}
                backspaceRemoves={false}
                validate={(e, field) =>
                  this.props.validate(e, this.props.fields.country)}
                onChange={event => this.onCountryChange(event)}
              />
            </div>
          ) : null}

          {this.props.fields.product.display ? (
            <div className='col-lg-3 m-b-15'>
              <Select
                searchable
                clearable={false}
                options={this.products}
                field={this.props.fields.product}
                onChange={this.handleProductSelect}
                validate={(e, field) =>
                  this.props.validate(e, this.props.fields.product)}
              />
            </div>
          ) : null}
          {this.props.fields.indicator.display ? (
            <div className='col-lg-3  m-b-15'>
              <Select
                searchable
                clearable={false}
                options={this.indications}
                field={this.props.fields.indicator}
                validate={(e, field) =>
                  this.props.validate(e, this.props.fields.indicator)}
              />
            </div>
          ) : null}

          {this.props.fields.deliveryMethod.display ? (
            <div className='col-lg-3  m-b-15'>
              <Select
                searchable
                clearable={false}
                placeholder={this.props.fields.deliveryMethod.placeholder}
                disabled={this.props.fields.deliveryMethod.disabled}
                options={this.deliveryMethods}
                field={this.props.fields.deliveryMethod}
                validate={(e, field) =>
                  this.props.validate(e, this.props.fields.deliveryMethod)}
                onChange={this.handleDeliveryMethodChange}
              />
            </div>
          ) : null}

          {this.props.fields.responseDeadline.display ? (
            <div className='col-lg-3  m-b-15'>
              <Select
                searchable
                clearable={false}
                // disabled={(StaticConfig.Context.Country.isGMISEnable != null) && (StaticConfig.Context.Country.isGMISEnable!=0) ? false : true}
                options={this.responseOptions}
                field={this.props.fields.responseDeadline}
                validate={(e, field) =>
                  this.props.validate(e, this.props.fields.responseDeadline)}
                onChange={this.handleResponseChange}
              />
            </div>
          ) : null}
          {this.props.fields.conference.display ? (
            <div className='col-lg-3  m-b-15'>
              {this.props.flowType === 'SCIBOOTH' ? (
                <Select
                  searchable
                  clearable={false}
                  options={this.props.conferenceOptions}
                  field={this.props.fields.conference}
                  validate={(e, field) =>
                    this.props.validate(e, this.props.fields.conference)}
                  onChange={this.props.onConferenceChange}
                />
              ) : (
                <InputGroup
                  field={this.props.fields.conference}
                  validate={(e, field) =>
                    this.props.validate(e, this.props.fields.conference)}
                />
              )}
            </div>
          ) : null}
        </div>

        {this.props.fields.question.display ? (
          <div className='row'>
            <div className='col-lg-12'>
              <Textarea
                rows={5}
                maxLength={4000}
                style={{ borderRadius: '4px' }}
                field={this.props.fields.question}
                validate={(e, field) =>
                  this.props.validate(e, this.props.fields.question)}
              />
            </div>
          </div>
        ) : null}

        {this.props.fields.respondedWith.display ? (
          <div className='row'>
            <div className='col-lg-12'>
              <TagGroup
                field={this.props.fields.respondedWith}
                validate={(e, field) =>
                  this.props.validate(e, this.props.fields.respondedWith)}
                ref={cd => (this.tagGroupField = cd)}
              />
            </div>
          </div>
        ) : null}

        {this.props.fields.followup.display ? (
          <div className='row'>
            <div className='col-lg-12'>
              <div className='form-group'>
                <label className='custom-control-description radio-label'>
                  {languageContent.module.submitInquiry.followup}
                </label>
                <br />
                <label className='custom-control custom-radio'>
                  <input
                    id='followUp-yes'
                    name='followUp'
                    className='custom-control-input'
                    value='Yes'
                    type='radio'
                    checked={this.props.fields.followup.value}
                    onChange={event => this.props.onFollowupChange(event)}
                  />
                  <span className='custom-control-indicator' />
                  <span className='custom-control-description'>
                    {languageContent.module.submitInquiry.yes}
                  </span>
                </label>
                <label className='custom-control custom-radio'>
                  <input
                    id='followUp-no'
                    name='followUp'
                    className='custom-control-input'
                    value='No'
                    type='radio'
                    checked={!this.props.fields.followup.value}
                    onChange={event => this.props.onFollowupChange(event)}
                  />
                  <span className='custom-control-indicator' />
                  <span className='custom-control-description'>
                    {languageContent.module.submitInquiry.no}
                  </span>
                </label>
              </div>
            </div>
          </div>
        ) : null}

        {flowType === 'SCIBOOTH' && this.props.fields.country.value !== "Italy" && (
          <div className='row'>
            <div className='col-lg-12'>
              <div className='form-group'>
                <label className='custom-control-description radio-label'>
                  {languageContent.module.submitInquiry.attachDocuments}
                </label>
                <br />
                <label className='custom-control custom-radio'>
                  <input
                    id='attachDocument-yes'
                    name='attachDocument'
                    className='custom-control-input'
                    type='radio'
                    value
                    checked={this.props.showDocs}
                    onChange={this.props.onAttachDocsRadio}
                  />
                  <span className='custom-control-indicator' />
                  <span className='custom-control-description'>
                    {languageContent.module.submitInquiry.yes}
                  </span>
                </label>
                <label className='custom-control custom-radio'>
                  <input
                    id='attachDocument-no'
                    name='attachDocument'
                    className='custom-control-input'
                    type='radio'
                    value={false}
                    checked={!this.props.showDocs}
                    onChange={this.props.onAttachDocsRadio}
                  />
                  <span className='custom-control-indicator' />
                  <span className='custom-control-description'>
                    {languageContent.module.submitInquiry.no}
                  </span>
                </label>
              </div>
            </div>
          </div>
        )}

        {this.props.showDocs && this.props.fields.conference.value && (
          <div>
            <AttachDocuments
              country={StaticConfig.Context.Country.name}
              conference={this.props.fields.conference.value}
              documents={this.props.documents}
              onCart={this.props.onCart}
              cart={this.props.cart}
              loading={this.props.loading}
            />
            <DocumentsCart
              documents={this.props.documents}
              handleCart={this.props.onCart /* eslint-disable-line */}
              cart={this.props.cart}
            />
          </div>
        )}
      </div>
    )
    return this.countriesMatched() ? jsx : null
  }
}

export default RequestInformation



// WEBPACK FOOTER //
// ./src/mi-app/submitInquiry/RequestInformation.js